<ng-container *ngIf="pointCloud$|async as pointCloud; else notSyncedYet">
  <div class="flex flex-col gap-12">
    <app-back-button *ngIf="!(standalone$ | async)" text="{{ 'page.project-detail.title' | translate: { name : (project$ | async)?.name } }}" link="/panel/projects/detail/{{ (project$ | async)?.id }}/point-clouds"></app-back-button>
    <app-back-button *ngIf="(standalone$ | async)" text="Back" link="/panel/point-clouds/unmatched"></app-back-button>

    <div class="flex items-center justify-between">
      <app-title>{{ 'page.point-cloud-detail.title' | translate:{ id : pointCloud.id } }}</app-title>

      <div class="flex items-center gap-2" *ngIf="project$ | async as project">
        <app-button appProjectAdminAccess [project]="project" text="{{ 'action.delete' | translate }}" variant="danger" icon="/assets/images/icon-trash.svg" (click)="deletePointCloud()"></app-button>
      </div>
    </div>

    <app-tabs>
      <app-tab text="{{ 'page.point-cloud-detail.tab.info' | translate }}" link="info"></app-tab>
      <app-tab text="{{ 'page.point-cloud-detail.tab.viewer' | translate }}" link="viewer"></app-tab>
    </app-tabs>

    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-container>

<ng-template #notSyncedYet>
  <div class="w-full flex items-center justify-center h-full text-sm text-gray-500 p-20 flex flex-col gap-5">
    <img ngSrc="/assets/images/synchronization.svg" [width]="100" [height]="100" />
    <div class="max-w-[30rem] text-center">
      {{ 'page.point-cloud-detail.not-synced-yet' | translate }}
    </div>
  </div>
</ng-template>
